module.exports = __webpack_public_path__ + "static/media/tessi.90653add.png";